// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3690":"0593339e","5006":"b2ca8117"}[chunkId] + ".css";
};